<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required", v-model="form.name", :label="translations.form.name")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseSelectField(rules="required", :items="competitionListAll", v-model="form.competition", :label="translations.form.competition")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseSelectField(rules="required", :items="matchsetsListAll", v-model="form.matchset", :label="translations.form.matchset")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required|numeric|min_value:0", v-model="form.multiplier", :label="translations.form.multiplier")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required|numeric|min_value:0", v-model="form.minpot", :label="translations.form.minpot")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required|numeric|min_value:0", v-model="form.budget", :label="translations.form.budget")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required|numeric|min_value:0", v-model="form.maxentries", :label="translations.form.maxentries")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required|numeric|min_value:0", v-model="form.entriesuser", :label="translations.form.entriesuser")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseSelectField(rules="required", :items="poolType", v-model="form.pooltype", :label="translations.form.pooltype")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseSelectField(rules="required", :items="payout", v-model="form.payout", :label="translations.form.payout")
          v-col(cols="12" sm="6" md="4" lg="4" v-if="form.payout === 'MUTUAL'")
            BaseSelectField(:rules="form.payout === 'MUTUAL' ? 'required' : ''", :items="categoriesListAll" v-model="form.category", :label="translations.form.category")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseSelectField(rules="required", :items="championshipFormat" v-model="form.format", :label="translations.form.format")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseSelectField(rules="required", :items="networkListAll" v-model="form.network", :label="translations.form.network")
          v-col(cols="12" sm="6" md="4" lg="4")
            v-select(:items="currencyItems" v-model="form.currency", :label="translations.form.currency")
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid"
              color="primary"
              type="submit"
              :loading="loadingCreate") {{ translations.buttons.create }}

</template>

<script>

  import { currencyList } from '@/store/variablesGlobals.js';

  export default {
    name: "ContestCreate",
    props: {
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      payout: {
        type: Array,
        default: function(){
          return []
        }
      },
      poolType: {
        type: Array,
        default: function(){
          return []
        }
      },
      championshipFormat: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      form: {
        name: '',
        competition: '',
        matchset: '',
        multiplier: '0',
        minpot: '0',
        budget: '200',
        maxentries: '1000',
        entriesuser: '0',
        payout: '',
        pooltype: 'NORMAL',
        format: '',
        network: '',
        currency: '',
        category: '',
      },
      currencyItems: currencyList.map(curr=> curr.text),
    }),
    computed: {
      loadingCreate() {
        return this.$store.state.statusCode.createContest.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.createContest.state;
      },
      competitionListAll() {
        return this.$store.state.fantasy.competitions.map(competition => (
          {
            text: competition.name,
            value: competition._id
          }
        ));
      },
      matchsetsListAll() {
        return this.$store.state.fantasy.matchsets.map(matchsets => (
          {
            text: `${matchsets.name} - ${this.dateFormated(matchsets.start)}`,
            value: matchsets._id
          }
        ));
      },
      categoriesListAll() {
        return this.$store.state.fantasy.categories.map(category => (
          {
            text: category.n,
            value: category._id
          }
        ));
      },
      networkListAll(){
        return this.$store.state.fantasy.networks.map(network => {
          return {
            text:network.n,
            value:network._id
          }
        })
      }
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.clearFields();
          this.$refs.validator.reset();
        }
      },
      stateCreate: function(val){
        if (val == 200) {
          this.$emit('successCreate');
        }
      },
    },
    created(){
      this.clearFields();

      this.$store.dispatch('getCompetitions');
      this.$store.dispatch('getMatchsets');
      this.$store.dispatch('getNetworks');
      this.$store.dispatch('getCategories');
    },
    methods:{
      submitDataForm(){
        const formSend = {
          data: {
            name: this.form.name,
            competition: this.form.competition,
            matchset: this.form.matchset,
            multiplier: parseInt(this.form.multiplier),
            minpot: parseInt(this.form.minpot),
            budget: parseInt(this.form.budget),
            maxentries: parseInt(this.form.maxentries),
            entriesuser: parseInt(this.form.entriesuser),
            payout: this.form.payout,
            pooltype: this.form.pooltype,
            format: this.form.format,
            network: this.form.network,
            currency: this.form.currency,
            category: this.form.category,
          }
        };
        this.$store.dispatch('createContest', formSend);
      },
      clearFields(){
        this.form.name = '';
        this.form.competition = '';
        this.form.matchset = '';
        this.form.multiplier = '0';
        this.form.minpot = '0';
        this.form.budget = '200';
        this.form.maxentries = '1000';
        this.form.entriesuser = '0';
        this.form.payout = '';
        this.form.pooltype = 'NORMAL';
        this.form.format = '';
        this.form.network = '';
        this.form.currency = '';
        this.form.category = '';
      },
      dateFormated(date){
        const dateFormat = new Date(date);
        return `${dateFormat.getDate()}-${dateFormat.getMonth() + 1}-${dateFormat.getFullYear()}`;
      },
    }
  }
</script>

<style lang="sass">
</style>